<template>
  <SingleSQ
    :questionData="questionData"
    :btnWidth="200"
    :oneOption="false"
    :pendingOption="false"
    :sq_numberData="'sq_twentyData'"
    :sqOptions="[ 5, 46]"
    @editQuestion="editQuestion"
    @deleteQuestion="deleteQuestion"
    @checkIfHistoryModeContinues="checkIfHistoryModeContinues"
    @reduceDecreasing="reduceDecreasing"
    @handleProgress="handleProgress">
  </SingleSQ>
</template>

<script>
import SingleSQ from '@/components/savings/blocks/SingleSQ'
import { singleQuesMethods } from '@/mixins/singleQuesMethods'

export default {
  name: 'SQuesTwenty',
  components: {
    SingleSQ
  },
  props: {
    questionData: Object
  },
  methods: {
    handleProgress (value) {
      if (value === 1) {
        this.$emit('handleProgress', 23)
      } else if (value === 2) {
        this.$emit('handleProgress', 23)
      } else if (value === 3) {
        this.$emit('handleProgress', 20)
      }
    }
  },
  mixins: [singleQuesMethods]
}
</script>
